export enum WoodEnvelopeTypeName {
  CLTSolidPanel = 'cltSolidPanel',
  TimberFrame = 'timberFrame'
}

export type WoodEnvelopeType =
  | WoodEnvelopeTypeName.CLTSolidPanel
  | WoodEnvelopeTypeName.TimberFrame;
